import {IServerService} from "../../domain/server/IServerService";
import {ApiAccessService} from "../api/ApiAccessService";

export class ServerService extends IServerService{

    private apiAccessService:ApiAccessService;

    constructor(apiAccessService:ApiAccessService){
        super();
        this.apiAccessService = apiAccessService;
    }

    public Initialize(): Promise<void> {
        return this.apiAccessService.Post("server/init");
    }
}


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/infrastructure/server/ServerService.ts